import { useEffect, useState } from "react"
import { addPayment, getAdminTeams, AddNewPaymentForm, Heading, Loading, Section, Team, TUser, EUserType, Button, Input } from '@sifrovacihra/shared-ui'
import { useAppState } from "../../store"

export const Admin = () => {
    const [loading, setLoading] = useState(false)
    const [teams, setTeams] = useState<TUser[]>([])
    const { state } = useAppState()
    const [variableSymbol, setVariableSymbol] = useState('')
    const [error, setError] = useState('')
    const [success, setSuccess] = useState('')

    useEffect(() => {
        if (state?.token) {
            getTeams(state.token)
        }
    }, [state?.token])

    useEffect(() => {
        console.log('Error: ', error)
        console.log('Success: ', success)
    }, [error, success])


    const getTeams = (token: string) => {
        setLoading(true)
        getAdminTeams({ token: token }).then((res) => {
            if (res.teams) {
                setTeams(res.teams.filter(t => t.Type === EUserType.TEAM))
            }
        }).finally(() => {
            setLoading(false)
        })
    }

    const getCSVEmails = () => {
        let list = Array<string>()
        teams.map(t => t.Players).flat(1).map(p => p?.Email).filter(e => e && e.length > 0).forEach(e => list.push(e || ''))
        list.sort((a, b) => a?.localeCompare(b || '', undefined, { sensitivity: 'base' }) || 0)

        const data = list.join("\n");
        const csvContent = `data:text/csv;charset=utf-8,${data}`;
        const encodedURI = encodeURI(csvContent);

        var link = document.createElement("a")
        link.href = encodedURI
        link.download = "Emaily.csv";
        link.click();
    }

    function getCSVRegistration(cathegory: string) {
        let list = Array<string>()
        teams.filter(t => t.Cathegory === cathegory)
            .forEach(t => {
            let row = t.Name + ";"
            row = row + t.Phone + ";"
            t.Players?.forEach(p => row = row + p.FullName + ";")
            list.push(row)
            })
        list.sort((a, b) => a?.localeCompare(b || '', undefined, { sensitivity: 'base' }) || 0)

        const data = list.join("\n");
        let csvContent = `data:text/csv;charset=utf-8,${data}`;
        csvContent = csvContent.replace('#', '')
        const encodedURI = encodeURI(csvContent);

        var link = document.createElement("a")
        link.href = encodedURI
        link.download = `Registrace_${cathegory}.csv`;
        link.click();
    }

    return (
        <>
            <Heading headline='Ke stažení' weight={1} />
            <Section>
                <div className='buttons'>
                    <button onClick={getCSVEmails} className='button'>Emaily</button>
                    <button onClick={() => getCSVRegistration('Z')} className='button'>Registrace Začátečníci</button>
                    <button onClick={() => getCSVRegistration('P')} className='button'>Registrace Pokročilí</button>
                </div>
            </Section>
            <AddNewPaymentForm
                teams={teams}
                variableSymbolPrefix={'2601'}
                variableSymbol={variableSymbol}
                onVariableSymbolChange={setVariableSymbol}
                setError={setError}
                setSuccess={setSuccess}
                addPayment={addPayment}
                token={state?.token!}
                loadTeams={() => getTeams(state?.token!)}
                ButtonComponent={Button}
                TextInputComponent={Input}
            />
            <Heading headline='Seznam týmů' weight={1} />
            <Section>
                <>
                    {loading ? <Loading /> : ''}
                    <Heading headline='Začátečníci' weight={3}/>
                    {teams.filter(t => t.Cathegory === 'Z').map(t => { return <Team team={t} admin = {true}></Team> })}

                    <Heading headline='Pokročilí' weight={3} />
                    {teams.filter(t => t.Cathegory === 'P').map(t => { return <Team team={t} admin={true}></Team> })}
                </>
            </Section>
        </>
    )
}
